import { render, staticRenderFns } from "./CardiologyDrawer.vue?vue&type=template&id=72dfdb44&scoped=true&"
import script from "./CardiologyDrawer.vue?vue&type=script&lang=js&"
export * from "./CardiologyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CardiologyDrawer.vue?vue&type=style&index=0&id=72dfdb44&scoped=true&lang=css&"
import style1 from "./CardiologyDrawer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dfdb44",
  null
  
)

export default component.exports